import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import FieldSet from 'flarum/common/components/FieldSet';
import NewsletterSettings from './components/NewsletterSettings';
import JoinRedirect from './components/JoinRedirect';
import SignupBox from './components/SignupBox';
app.initializers.add('voucha-newsletter', () => {
  // For other extensions (e.g. the calculators): m(app.vouchaNewsletter.SignupBox, { source, preselect })
  app.vouchaNewsletter = {
    SignupBox
  };
  app.routes['voucha-newsletter.join'] = {
    path: '/join',
    component: JoinRedirect
  };

  // SettingsPage is lazy-loaded in Flarum 2, so it has to be extended by
  // module path; the callback runs once the page's chunk has loaded.
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    if (!app.session.user) return;
    items.add('vouchaNewsletter', m(FieldSet, {
      className: "Settings-vouchaNewsletter FieldSet--min",
      label: "Newsletters"
    }, m(NewsletterSettings, null)), -10);
  });
});